import React, { Suspense, useMemo, useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "../Layouts/Header";
import { useApiLoader } from "@/shared/context/ApiLoaderContext";
import BarLoader from "../Loader/BarLoader";
import { ToastContainer } from "react-toastify";
import Footer from "./Footer";
import Sidebar from "./Sidebar";
import TrialExpiryGuard from "./TrialExpiryGuard";

const Layout = (): React.ReactElement => {
  const [sidebarClose, setSidebarClose] = useState<boolean>(false);
  const [openValue, setOpenValue] = useState<string>("");
  const { isLoading } = useApiLoader();

  const contentWidthClass = useMemo(() => {
    return sidebarClose
      ? "w-full md:w-[calc(100vw-72px)]"
      : "w-full md:w-[calc(100vw-240px)]";
  }, [sidebarClose]);

  return (
    <div className="min-h-screen overflow-hidden">
      <TrialExpiryGuard />
      {/* Header Area */}
      <Header
        sidebarClose={sidebarClose}
        setSidebarClose={setSidebarClose}
        setOpenValue={setOpenValue}
      />
      <div className="flex relative bg-background h-full">
        {/* Sidebar Area */}
        <Sidebar
          sidebarClose={sidebarClose}
          setSidebarClose={setSidebarClose}
          openValue={openValue}
          setOpenValue={setOpenValue}
        />
        <div
          data-testid="layout-content"
          className={`pt-13 xs:pt-16 h-full transition-all duration-500 ${contentWidthClass}`}
        >
          {/* Content Area */}
          <div className="pl-4 md:pl-3 pr-4 h-[calc(100vh-64px)] overflow-y-auto flex-col flex justify-between">
            {isLoading && <BarLoader />}
            <main className="pt-3 sm:pt-5">
              <Suspense fallback={null}>
                <Outlet />
                <ToastContainer />
              </Suspense>
            </main>
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Layout;
